import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { ARWMButton } from './ARWMButton';
export function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    label: 'Accueil',
    path: '/'
  }, {
    label: 'À propos',
    path: '/a-propos'
  }, {
    label: 'Adhérents',
    path: '/adherents'
  }, {
    label: 'Événements',
    path: '/events'
  }, {
    label: 'Guide Invest',
    path: '/ouvrir-son-restaurant'
  }, {
    label: 'Utilitaires',
    path: '/informations-utiles'
  }, {
    label: 'Emploi',
    path: '/career'
  }, {
    label: 'Blog',
    path: '/blog'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <nav className="sticky top-0 z-50 bg-arwm-white shadow-sm" data-id="element-59">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        <div className="flex items-center justify-between h-[98px]" data-id="element-61">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-62">
            <img src="https://cdn.magicpatterns.com/uploads/a4uCYUHs7GFxaJeXiCw9Gk/694bca615babcc4e4abf88c3_Gemini_Generated_Image_qiw702qiw702qiw7_(1)-p-1600.png" alt="ARWM - Association des Restaurateurs de la Wilaya de Marrakech" className="h-16 w-auto" data-id="element-63" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-64">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`font-josefin text-sm transition-colors ${isActive(link.path) ? 'text-arwm-maroon font-semibold' : 'text-arwm-dark-text hover:text-arwm-maroon'}`} data-id="element-65">
                {link.label}
              </Link>)}
            <Link to="/contact" data-id="element-66">
              <ARWMButton data-id="element-67">Contact</ARWMButton>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2 text-arwm-dark-text" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-68">
            {mobileMenuOpen ? <X size={24} data-id="element-69" /> : <Menu size={24} data-id="element-70" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="lg:hidden py-4 border-t border-gray-200" data-id="element-71">
            <div className="flex flex-col space-y-4" data-id="element-72">
              {navLinks.map(link => <Link key={link.path} to={link.path} className={`font-josefin text-sm px-4 py-2 ${isActive(link.path) ? 'text-arwm-maroon font-semibold' : 'text-arwm-dark-text'}`} onClick={() => setMobileMenuOpen(false)} data-id="element-73">
                  {link.label}
                </Link>)}
              <Link to="/contact" className="px-4" onClick={() => setMobileMenuOpen(false)} data-id="element-74">
                <ARWMButton className="w-full" data-id="element-75">Contact</ARWMButton>
              </Link>
            </div>
          </div>}
      </div>
    </nav>;
}